import PropTypes from 'prop-types';
import styled from 'styled-components';

import ButtonPattern from '@mlb/react-patterns/components/Button/button.tsx';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';

const ReelsButton = styled(ButtonPattern).attrs((props => ({
    iconName: 'reels',
    iconSize: '30',
    size: 'lg',
    label: props.label,
    styleName: 'default',
    shape: 'hollow-borderless',
    handlers: {
        onClick: props.onClick,
    },
    disabled: props.disabled,
})))`
    &&& {
        position: relative;
        display: flex;
        align-items: center;
        line-height: 1.2;
        font-size: 15px;
        ${({ clipsNumber }) => !!clipsNumber && (`
            &::before {
                content: '${clipsNumber}';
                position: absolute;
                top: 0px;
                left: 0px;
                width: 18px;
                height: 18px;
                background-color: ${COLORS.liveYellow};
                color: ${COLORS.mlbGrey8};
                border-radius: 50%;
                line-height: 19px;
                font-family: ${FONTS.primaryFont};
                font-size: 12px;
                font-weight: bold;
                z-index: 1;
            }
        `)}
        ${IconWrapper} {
            stroke: none;
            padding-top: 0;
        }
    }
`;

ReelsButton.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    rightLabel: PropTypes.string,
    clipsNumber: PropTypes.number,
    disabled: PropTypes.bool,
};

ReelsButton.defaultProps = {
    rightLabel: undefined,
    clipsNumber: undefined,
    disabled: false,
};

export default ReelsButton;
